import { render, staticRenderFns } from "./TemplatePersonalization.vue?vue&type=template&id=37c5d237&scoped=true"
import script from "./TemplatePersonalization.vue?vue&type=script&lang=js"
export * from "./TemplatePersonalization.vue?vue&type=script&lang=js"
import style0 from "./TemplatePersonalization.vue?vue&type=style&index=0&id=37c5d237&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c5d237",
  null
  
)

export default component.exports